import Grid from '@mui/material/Grid';
import { getTicketById } from '_models/redux/get-ticket-by-id/action';
import { cleanTicketById } from '_models/redux/get-ticket-by-id/clean-action';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import CustomerProfileHeaderClient from '../userTickets/components/CustomerProfileHeaderClient';
import ActionsBar from './components/ActionBar';
import ErrorPage from './components/ErrorPage';
import HeaderTitle from './components/HeaderTitle';
import TicketInfo from './components/TicketInfo';
import TabsTicket from './TabsTicket';

const DetailTicketsPage = (props) => {
  const location = useLocation();
  console.log('location:', location);
  const params = useParams(props);

  const titleTicket = props?.ticketById?.response?.title;
  const [ticketById, setTicketById] = useState();
  const [directNumberById, setDirectNumberByID] = useState();
  const [billingCycleInfo, setBillingCycleInfo] = useState();

  useEffect(() => {
    setTicketById(params.ticketId);

    props.getTicketById({ ticketId: params.ticketId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const response = props.ticketById.response || undefined;

    if (typeof response !== 'undefined') {
      setDirectNumberByID(response.direct_number);
      setTicketById(response.id);
    }
  }, [props.ticketById]);

  return (
    <Grid container maxWidth={'97%'}>
      {props?.ticketById?.status === 200 ? (
        <>
          <Grid item size={{ xs: 9 }} className='tabs-container'>
            <HeaderTitle
              ticketById={props?.ticketById}
              directNumber={directNumberById}
              ticketId={ticketById}
              titleTicket={titleTicket}
            />
            <TabsTicket billingCycleInfo={billingCycleInfo} />
          </Grid>
          <Grid item size={{ xs: 3 }} className='ticket-bar'>
            <TicketInfo ticketId={ticketById} />
            <CustomerProfileHeaderClient
              ticketId={ticketById}
              directNumber={directNumberById}
              setBillingCycleInfo={setBillingCycleInfo}
            />
            <ActionsBar />
          </Grid>
        </>
      ) : props?.ticketById?.error?.response?.status > 200 ? (
        <ErrorPage
          cleanTicketById={props.cleanTicketById}
          messageResponseTickets={props?.ticketById?.error?.response?.data?.detail}
        />
      ) : null}
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  tickets: state.tickets,
  ticketById: state.ticketById,
});

const mapDispatchToProps = {
  getTicketById,
  cleanTicketById,
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailTicketsPage);
